// extracted by mini-css-extract-plugin
module.exports = {"feedback":"styles_feedback__k-Pmb"};